






































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {ConvertModule, IBudget, ICampaign, ILocation} from '../stores/modules/convert';
import {WebService} from '../services/web.service';
import { remove, findIndex } from 'lodash';
import CloseIcon from '../assets/icon-close-x.svg';
import moment from 'moment';

@Component({
	components: {
		CloseIcon: CloseIcon
	}
})
export default class CampaignModal extends Vue {
	@Prop() private programId!: string;
	@Prop() private locationBase!: string;
	currentStep = 0;

	@Watch('locationBase')
	onLocationBaseChange(val: string, oldVal: string) {
		this.onLocationBaseOrProductIdChange();
	}

	@Watch('programId')
	onProductIdChange(val: string, oldVal: string) {
		this.onLocationBaseOrProductIdChange();
	}

	async onLocationBaseOrProductIdChange() {
		if(this.locationBase !== undefined && this.programId !== undefined && this.activeCampaign !== null && (this.activeCampaign.budgetId === null || !this.activeCampaign.enabled)) {
			const budgetId = (this.budgets.length > 1 ? this.budgets[1] : this.budgets[0] as IBudget).id;
			this.currentStep = 0;
			console.log('SETTING', budgetId);
			ConvertModule.setActiveBudgetBase({
				locationBase: this.locationBase,
				programId: this.programId,
				budgetId: budgetId
			});
		}
		// If we are editing an already enabled campaign then jump to the summary page
		if(this.activeCampaign !== null && this.activeCampaign.enabled) {
			this.currentStep = 2;
		}
	}

	get location() {
		console.log('BASE: ', this.locationBase);
		if(this.locationBase === undefined) {
			return null;
		}
		return ConvertModule.locationByBase(this.locationBase);
	}

	get budgets() {
		if(this.locationBase === undefined || this.programId === undefined) {
			return [];
		}
		return ConvertModule.budgetsByLocationBaseAndProgramId(this.locationBase as string, this.programId);
	}

	get activeCampaign() {
		return ConvertModule.campaignByLocationBaseAndProgramId(this.locationBase, this.programId);
	}

	get activeCampaignBudget() {
		if(this.activeCampaign === null || this.activeCampaign.budgetId === null) {
			return null;
		}
		return ConvertModule.budgetById(this.activeCampaign.budgetId);
	}

	setBudget($event: {oldValue: number, newValue: number}) {
		ConvertModule.setActiveBudgetBase({
			locationBase: this.locationBase,
			programId: this.programId,
			budgetId: this.budgets[$event.newValue].id
		});
	}


	get budgetIndex() {
		if(this.activeCampaign === null || this.activeCampaign.budgetId === null) {
			return 0;
		}
		return findIndex(this.budgets, {id: this.activeCampaign.budgetId});
	}

	alert(msg: string) {
		alert(msg);
	}

	async save() {
		await WebService.saveCampaign(this.activeCampaign as ICampaign);
		await WebService.getCampaigns(this.locationBase);
		this.$bvModal.hide('campaign-modal');
	}

	async disable() {
		await WebService.disableCampaign(this.activeCampaign as ICampaign);
		await WebService.getCampaigns(this.locationBase);
		this.$bvModal.hide('campaign-modal');
		this.$emit('close');
	}

	async close() {
		// Refetch campaigns in case we edited it
		await WebService.getCampaigns(this.locationBase);
		this.$bvModal.hide('campaign-modal');
		this.$emit('close');
	}

	getTimeSince(timestamp: number) {
		return moment.unix(timestamp).fromNow(true);
	}
}
